import Input from "../../ReactHookForms/Input"
import TextArea from "../../ReactHookForms/TextArea"
import UploadImage from "../../ReactHookForms/UploadImage"

const SeoContainer = () => {
  return (
    <div className="w-full xl:w-[40%] px-8 md:py-8">
      <Input label="Meta Title" id="title" maxLength={65} />
      <TextArea label="Meta Description" id="description" maxLength={165} />
      <div className="md:w-1/2">
        <UploadImage
          label="Meta Image"
          id="image"
          noCrop={true}
          className="!h-[300px]"
        />
      </div>
    </div>
  )
}

export default SeoContainer
